import {
  listInvoicesForMultipleOrders as publicListInvoicesForMultipleOrders,
  generateInvoice as publicGenerateInvoice,
  bulkGenerateInvoices as publicBulkGenerateInvoices,
  addInvoiceToOrder as publicAddInvoiceToOrder,
} from './ecom-orders-v1-invoice-order-invoices.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listInvoicesForMultipleOrders: MaybeContext<
  BuildRESTFunction<typeof publicListInvoicesForMultipleOrders> &
    typeof publicListInvoicesForMultipleOrders
> = /*#__PURE__*/ createRESTModule(publicListInvoicesForMultipleOrders);
/** @internal */
export const generateInvoice: MaybeContext<
  BuildRESTFunction<typeof publicGenerateInvoice> & typeof publicGenerateInvoice
> = /*#__PURE__*/ createRESTModule(publicGenerateInvoice);
/** @internal */
export const bulkGenerateInvoices: MaybeContext<
  BuildRESTFunction<typeof publicBulkGenerateInvoices> &
    typeof publicBulkGenerateInvoices
> = /*#__PURE__*/ createRESTModule(publicBulkGenerateInvoices);
/** @internal */
export const addInvoiceToOrder: MaybeContext<
  BuildRESTFunction<typeof publicAddInvoiceToOrder> &
    typeof publicAddInvoiceToOrder
> = /*#__PURE__*/ createRESTModule(publicAddInvoiceToOrder);

export { WebhookIdentityType } from './ecom-orders-v1-invoice-order-invoices.universal.js';
export {
  Invoice,
  ListInvoicesForSingleOrderRequest,
  ListInvoicesForSingleOrderResponse,
  ListInvoicesForMultipleOrdersRequest,
  ListInvoicesForMultipleOrdersResponse,
  InvoicesForOrder,
  GenerateInvoiceRequest,
  GenerateInvoiceResponse,
  BulkGenerateInvoicesRequest,
  BulkGenerateInvoicesResponse,
  BulkInvoiceResult,
  ItemMetadata,
  ApplicationError,
  InvoiceForOrder,
  BulkActionMetadata,
  AddInvoiceToOrderRequest,
  AddInvoiceToOrderResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  GetOrderInvoiceRequest,
  GetOrderInvoiceResponse,
  GenerateInvoiceWithNumberRequest,
  GenerateInvoiceWithNumberResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  ListInvoicesForMultipleOrdersResponseNonNullableFields,
  GenerateInvoiceResponseNonNullableFields,
  BulkGenerateInvoicesResponseNonNullableFields,
  AddInvoiceToOrderResponseNonNullableFields,
} from './ecom-orders-v1-invoice-order-invoices.universal.js';
